//使用当前的变量的文件包括： mobile.js\common.js，m-index.js,m-common.js,index.ejs
//视频路径
//http://website.chinarenaissance.com/
var api = {
    pcApi: 'https://website.huaxing.com/',
    webApi: 'https://website.huaxing.com/',
    // 视频链接
    pcVideo: 'https://www.huaxing.com/',
    webVideo: 'https://www.huaxing.com/',
    // minio url
    minioUrl: 'https://oss.huaxing.com/www-public',
}
if (process.env.API_ENV === 'test') {
    api = {
        pcApi: 'https://website-test.huaxing.com/',
        webApi: 'https://website-test.huaxing.com/',
        // 视频链接
        pcVideo: 'https://www.huaxing.com/',
        webVideo: 'https://www.huaxing.com/',
        // minio url
        minioUrl: 'https://oss-test.huaxing.com/www-public',
    }
}

exports.api = api;


// WEBPACK FOOTER //
// ./commonApi.js